const MuiTablePagination = {
    defaultProps: {
        nextIconButtonProps: {
            size: 'small'
        },
        backIconButtonProps: {
            size: 'small'
        }
    },
    styleOverrides: {
        root: ({ theme })=>({
                backgroundColor: theme.palette.background.default
            }),
        toolbar: {
            minHeight: 36
        },
        select: ({ theme })=>({
                ...theme.typography.body2
            })
    }
};
export { MuiTablePagination };

//# sourceMappingURL=table-pagination.js.map